import React from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { Modal } from '~/components/_layouts'
import { Button } from '~/lib/ui/button'
import { useBenefits } from '../BenefitsProvider'

const StrengthsAssessmentRequestedDialog = ({
  noShow,
  serviceRequest,
  strengthsCode,
  buttonText,
}) => {
  const { t } = useTranslation('StrengthsAssessment.request_submitted_dialog')
  const {
    requestStrengthsAssessmentCode,
    showCodeRequestedConfirmDialog,
    setShowCodeRequestedConfirmDialog,
  } = useBenefits()

  if (!showCodeRequestedConfirmDialog)
    return (
      <Button onClick={requestStrengthsAssessmentCode} variant={'outline'}>
        {noShow
          ? t('reschedule_meeting')
          : serviceRequest && !strengthsCode
            ? 'Code Requested'
            : buttonText}
      </Button>
    )

  return (
    <Modal
      open={showCodeRequestedConfirmDialog}
      onClose={() => setShowCodeRequestedConfirmDialog(false)}
      title={t('title')}
      size="md"
      actions={[
        <Button
          onClick={() => setShowCodeRequestedConfirmDialog(false)}
          key="cancel"
          variant="ghost"
        >
          {t('close')}
        </Button>,
      ]}
    >
      <div>{t('message')}</div>
    </Modal>
  )
}

export default StrengthsAssessmentRequestedDialog
